import CartaoFidelidade from "./CartaoFidelidade";
import { vencimento } from "./premios";
import useCartaoFidelidade from "./useCartaoFidelidade";

/**
 * Ficha do cliente (Pessoas e Fornecedores → Clientes): o cartão dele e os
 * prêmios a usar, com o código — é o que o garçom digita no cupom das Mesas.
 * Não abre cartão novo (só mostra o que existe).
 */
export default function CartaoDoCliente({ clienteId }) {
  const { estado, premios } = useCartaoFidelidade(clienteId, null, { autenticado: true });
  if (!estado || (!estado.cartao?.participa && !premios.length)) return null;
  return (
    <div className="rounded-xl border p-4 grid gap-4 sm:grid-cols-[minmax(0,320px)_1fr] items-center" data-e2e="cartao-do-cliente">
      {estado.cartao?.participa ? <CartaoFidelidade loja={estado.loja} cartao={estado.cartao} animado={false} /> : <div />}
      <div className="text-sm space-y-2">
        <p className="font-semibold">Cartão fidelidade</p>
        {estado.cartao?.participa && (
          <p className="text-muted-foreground">
            {estado.cartao.carimbos}/{estado.cartao.total} carimbos · {estado.cartao.status === "aguardando"
              ? "completo, esperando o pedido ser concluído"
              : `faltam ${estado.cartao.faltam} para ${estado.cartao.premio?.texto || "o prêmio"}`}
          </p>
        )}
        {premios.map((p) => (
          <p key={p.codigo} className="rounded-lg bg-amber-500/10 border border-amber-500/30 px-3 py-2">
            🎁 <b>{p.texto}</b> · código <b className="font-mono">{p.codigo}</b> · vale até {vencimento(p.vence_em)}
          </p>
        ))}
      </div>
    </div>
  );
}
